import TermsBulkUploadContainer from "./TermsBulkUploadContainer";
export default TermsBulkUploadContainer;
